import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SelectItem} from "primeng/primeng";
import {DocumentCategoryService} from "../../../../service/repository/document-category.service";
import {GlobalAppService} from "../../../../../core/commons/global-app.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DocumentCategory} from "../../../../domain/documentCategory";
import {MessageSeverity} from "../../../../../core/commons/message-severity";

@Component({
    selector: 'app-document-category-form',
    templateUrl: './document-category-form.component.html',
    styleUrls: ['./document-category-form.component.scss'],
    providers: [ DocumentCategoryService ]
})
export class DocumentCategoryFormComponent implements OnInit {

    documentForm: FormGroup = null;
    update: boolean = false;
    title: string = "";
    categories: SelectItem[] = [{label: "Selecciona una opcion", value: null}];

    constructor(private formBuilder: FormBuilder,
                private categoryService : DocumentCategoryService,
                private messageService: GlobalAppService,
                private route: ActivatedRoute,
                private router: Router) {
    }

    ngOnInit() {

        this.documentForm = this.formBuilder.group({
            id: [null],
            name: ['', [ Validators.required , Validators.maxLength(1500) ] ],
            parentCategory: [null]
        });

        let id = this.route.params
            .map(params => params['id']);

        id.filter(id => id != 'new')
            .switchMap(id => this.categoryService.get(+id))
            .subscribe(c => {
                this.title = "Edición de la categoria";
                this.documentForm.get('id').setValue(c.id);
                this.documentForm.get('name').setValue(c.name);
                if (c.parentCategory)
                    this.documentForm.get('parentCategory').setValue(c.parentCategory);
                this.update = true;
            });

        id.filter(id => id == 'new')
            .subscribe(id => {
                this.title = "Nueva categoria";
            });

        this.categoryService.getAll()
            .map(categories =>
                categories.map(c => {
                    c.parentCategory = null;
                    return ( {label: c.name, value: c} );
                })
            )
            .subscribe(categories => {
                this.categories  = this.categories.concat(categories);
            });
    }

    public onSubmit({value, valid}) {
        if (valid) {
            let c = new DocumentCategory(value);
            this.messageService.setLoading(true);
            if (!this.update) {
                this.categoryService.create(c).subscribe(c => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, "Exito!", "La categoria se creo con exito.");
                    this.messageService.setLoading(false);
                    this.router.navigate(["home", "repository","category"]);
                });
            } else {
                this.categoryService.update(c).subscribe(c => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, "Categoria modificado", "La categoria se modifico con exito.");
                    this.messageService.setLoading(false);
                    this.router.navigate(["home", "repository","category"]);
                });
            }

        }
    }

    public goBack() {
        this.router.navigate(["home", "repository","category"]);
    }
}


// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/document-category/form/document-category-form.component.ts